import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat"
import utc from "dayjs/plugin/utc"
import timezone from "dayjs/plugin/timezone"
dayjs.extend(advancedFormat)
dayjs.extend(utc)
dayjs.extend(timezone)

function formatDate(time, mask) {
    return dayjs(time).format(mask);
}

function formatCountdown(ms) {
    if (ms <= 0) {
        return "00:00:00";
    }

    let seconds = Math.round(ms / 1000);
    let minutes = Math.trunc(seconds / 60);
    seconds = seconds % 60;
    let hours = Math.trunc(minutes / 60);
    minutes = minutes % 60;

    return `${_toString(hours)}:${_toString(minutes)}:${_toString(seconds)}`;

    function _toString(i) {
        if (i < 10) {
            return "0" + i;
        }
        return i;
    }
}

function toIsoString(time){
    return formatDate(time, "YYYY-MM-DD") + "T" + formatDate(time, "HH:mm:ss");
}

export {
    formatDate,
    formatCountdown,
    toIsoString
}
